var map = {
	"../components/login/login-layout-1.module": [
		870,
		48
	],
	"../pages/cb001-homepage/cb001-homepage.module": [
		871,
		49
	],
	"../pages/mod-act/act100-payment-request-list/act100-payment-request-list.module": [
		872,
		47
	],
	"../pages/mod-act/act101-purchasing-request-list/act101-purchasing-request-list.module": [
		873,
		46
	],
	"../pages/mod-act/act102-advance-request-list/act102-advance-request-list.module": [
		874,
		45
	],
	"../pages/mod-animal/tcv008-animal-categories/tcv008-animal-categories.module": [
		877,
		44
	],
	"../pages/mod-animal/tcv009-category-detail/tcv009-category-detail.module": [
		875,
		43
	],
	"../pages/mod-animal/tcv010-animal-profile/tcv010-animal-profile.module": [
		876,
		42
	],
	"../pages/mod-common/acom000-system-settings/acom000-system-settings.module": [
		878,
		41
	],
	"../pages/mod-common/acom001-news/acom001-news.module": [
		879,
		40
	],
	"../pages/mod-common/acom800-ciibos-list-view/acom800-ciibos-list-view.module": [
		880,
		39
	],
	"../pages/mod-common/acom801-modal-prompt/acom801-modal-prompt.module": [
		881,
		38
	],
	"../pages/mod-common/com100-barcode-scanner/com100-barcode-scanner.module": [
		882,
		5
	],
	"../pages/mod-pos/pos005-tablelist/pos005-tablelist.module": [
		883,
		37
	],
	"../pages/mod-pos/pos006-poslist/pos006-poslist.module": [
		884,
		36
	],
	"../pages/mod-pos/pos008-waiter-screen/pos008-waiter-screen.module": [
		885,
		35
	],
	"../pages/mod-pos/pos009-categorylist/pos009-categorylist.module": [
		886,
		34
	],
	"../pages/mod-pos/pos010-productlist/pos010-productlist.module": [
		887,
		33
	],
	"../pages/mod-pos/pos012-waiter-tables-in-service/pos012-waiter-tables-in-service.module": [
		888,
		32
	],
	"../pages/mod-pos/pos015-waiter-task-on-services/pos015-waiter-task-on-services.module": [
		889,
		31
	],
	"../pages/mod-pos/pos016-tables-transactions/pos016-tables-transactions.module": [
		890,
		30
	],
	"../pages/mod-pos/pos017-tables-details-transactions/pos017-tables-details-transactions.module": [
		891,
		29
	],
	"../pages/mod-pos/pos020-pos-order/pos020-pos-order.module": [
		892,
		4
	],
	"../pages/mod-pos/pos021-pos-ticket/pos021-pos-ticket.module": [
		893,
		3
	],
	"../pages/mod-pos/pos022-pos-ticketlist/pos022-pos-ticketlist.module": [
		895,
		28
	],
	"../pages/mod-pos/pos025-pos-payment/pos025-pos-payment.module": [
		894,
		27
	],
	"../pages/mod-pos/pos028-pos-order-notes/pos028-pos-order-notes.module": [
		896,
		26
	],
	"../pages/mod-pos/pos030-gamesticket/pos030-gamesticket.module": [
		897,
		2
	],
	"../pages/mod-pos/pos031-parkingticket/pos031-parkingticket.module": [
		898,
		25
	],
	"../pages/mod-pos/pos032-generalticket/pos032-generalticket.module": [
		899,
		1
	],
	"../pages/mod-pos/pos033-fast-order-service/pos033-fast-order-service.module": [
		900,
		0
	],
	"../pages/mod-pos/pos034-fast-order-filter-category/pos034-fast-order-filter-category.module": [
		901,
		24
	],
	"../pages/mod-pos/pos035-fast-order-payment/pos035-fast-order-payment.module": [
		902,
		23
	],
	"../pages/mod-pos/pos036-fast-order-filter-product/pos036-fast-order-filter-product.module": [
		903,
		22
	],
	"../pages/mod-pos/pos300-client-order-transaction/pos300-client-order-transaction.module": [
		904,
		21
	],
	"../pages/mod-pos/pos303-client-order-cancel/pos303-client-order-cancel.module": [
		905,
		20
	],
	"../pages/mod-pos/pos305-client-order-tracking/pos305-client-order-tracking.module": [
		906,
		19
	],
	"../pages/mod-pos/pos330-generic-dashboard/pos330-generic-dashboard.module": [
		907,
		18
	],
	"../pages/mod-pos/pos340-ciibos-order-transaction/pos340-ciibos-order-transaction.module": [
		908,
		17
	],
	"../pages/mod-pos/pos345-gate-order-transaction/pos345-gate-order-transaction.module": [
		909,
		16
	],
	"../pages/mod-pos/pos350-tickettransaction/pos350-tickettransaction.module": [
		910,
		15
	],
	"../pages/mod-pos/pos351-tickettransaction-by-user/pos351-tickettransaction-by-user.module": [
		911,
		14
	],
	"../pages/mod-pos/pos355-top-product/pos355-top-product.module": [
		912,
		13
	],
	"../pages/mod-pos/pos360-food-transaction/pos360-food-transaction.module": [
		913,
		12
	],
	"../pages/mod-pos/pos800-client-voucher/pos800-client-voucher.module": [
		914,
		11
	],
	"../pages/mod-pos/pos900-product-sync-management/pos900-product-sync-management.module": [
		915,
		10
	],
	"../pages/mod-pos/woo001-approve-web-orders/woo001-approve-web-orders.module": [
		916,
		9
	],
	"../pages/mod-user/amis-001-login/amis-001-login.module": [
		917,
		8
	],
	"../pages/mod-user/change-password/change-password.module": [
		918,
		7
	],
	"../pages/printer-list-modal/printer-list-modal.module": [
		919,
		6
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 216;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 216
// module chunks = 50